import type { Error } from '../types';
import { CONTAIN_INT_AND_DEC_NUMBERS } from '../utils/regex';

export const mustContainIntAndDecNumbers =
  (message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && CONTAIN_INT_AND_DEC_NUMBERS.test(value),
    message
  });
